module.exports = __webpack_public_path__ + "img/Pic_TB_A.41a9b372.png";